import { __decorate } from "tslib";
import { html, css, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { when } from 'lit/directives/when.js';
let ViedocLink = class ViedocLink extends LitElement {
    constructor() {
        super(...arguments);
        this.underlined = false;
        this.ariaLabel = '';
    }
    render() {
        const classNames = classMap({
            link: true,
            [`link--underlined`]: this.underlined,
        });
        return html `
      <a
        class=${classNames}
        download=${ifDefined(this.download)}
        href=${ifDefined(this.href)}
        target=${ifDefined(this.target)}
        aria-label=${this.ariaLabel}
      >
        ${when(this.prefixIcon, () => html `<viedoc-icon
              class="link__icon link__icon--prefix"
              name=${this.prefixIcon}
              part="prefix-icon"
            ></viedoc-icon>`)}
        <slot class="link__content"></slot>
        ${when(this.suffixIcon, () => html `<viedoc-icon
              class="link__icon link__icon--suffix"
              name=${this.suffixIcon}
              part="suffix-icon"
            ></viedoc-icon>`)}
      </a>
    `;
    }
};
ViedocLink.styles = [
    css `
      :host {
        display: inline-block;
        --viedoc-link-white-space: normal;
      }

      .link {
        font-family: var(--font-family-monument);
        font-size: inherit;
        text-decoration: none;
        display: flex;
        align-items: center;
        color: var(--link-color);
        transition:
          color 200ms,
          text-decoration-color 200ms;
      }

      .link--underlined {
        text-underline-offset: 0.25rem;
        text-decoration: underline;
        text-decoration-color: var(--color-gray-30);
      }

      .link__content {
        white-space: var(--viedoc-link-white-space);
      }

      :host(:hover) .link--underlined {
        text-decoration-color: var(--link-color);
      }

      .link__icon {
        height: 1.2rem;
      }

      .link__icon--prefix {
        margin-right: 0.25rem;
      }

      .link__icon--suffix {
        margin-left: 0.25rem;
      }
    `,
];
__decorate([
    property({ type: String })
], ViedocLink.prototype, "download", void 0);
__decorate([
    property({ type: String })
], ViedocLink.prototype, "href", void 0);
__decorate([
    property({ type: String, attribute: 'prefix-icon' })
], ViedocLink.prototype, "prefixIcon", void 0);
__decorate([
    property({ type: String, attribute: 'suffix-icon' })
], ViedocLink.prototype, "suffixIcon", void 0);
__decorate([
    property({ type: String })
], ViedocLink.prototype, "target", void 0);
__decorate([
    property({ type: Boolean })
], ViedocLink.prototype, "underlined", void 0);
__decorate([
    property({ type: String, attribute: 'aria-label' })
], ViedocLink.prototype, "ariaLabel", void 0);
ViedocLink = __decorate([
    customElement('viedoc-link')
], ViedocLink);
export { ViedocLink };
